import React, { useEffect, useState } from "react";
import { Button } from "flowbite-react"
import { useSelector } from "react-redux";
import { useRoadmapService } from "../../services";
import { HiOutlineZoomIn,HiOutlineZoomOut } from "react-icons/hi";

import TaskCompletionUpdateModal from "../../pages/Projects/sections/TaskTableModal";
import TemplateTaskTableModal from "../../pages/Templates/TemplatesView/sections/TaskTableModal";
import GanntNew from "../../pages/Projects/GanntNew";
const GANTT_VIEW_NEW = process.env.REACT_APP_GANTT_VIEW_NEW

const GanttView = (props: any) => {
    const {  project_id = '', sim_flag = false,token,isToken=false,isTemplate=false } = props;
    const [projectId, setProjectId] = useState('')
    const { fetchData,fetchProjectShareData } = useRoadmapService();
    const [tasks, setTasks] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [current, setCurrent] = useState(null);
    const [ZoomClick, setZoomClick] = useState(false);
    const [scale, setScale] = useState(1);

    const { data, members, loading,duration,
        duration_with_working_days,duration_with_delay } = useSelector((state: any) => state.roadmap);
    const { hasSimulationTasks } = useSelector((state: any) => state.projects);

    const handleDblClick = (task: any) => {
        // alert("On Double Click event Id:" + task.id);
        if (task.type !== "project" && (project_id || projectId) && !isToken) {
            setCurrent(task);
            setShowModal(!showModal)
        }

    };

    useEffect(() => {
        if (project_id) {
            setProjectId(project_id);
        }
    }, [project_id])

    useEffect(() => {
        if(projectId && !isToken){
            fetchData(projectId, sim_flag, {});
        }
        if(token && isToken){
            fetchProjectShareData(token, sim_flag, {});
        }
    }, [projectId, token, sim_flag, isToken]);

    useEffect(() => {
        if (data && data.length && !loading) {
            const copyData = [...data]
            let tasksData: any = copyData.map((td: any) => {
                const duration = Math.round((new Date(td?.end) - new Date(td?.start)) / 24 / 60 / 60 * .001);
                return {
                    ...td,
                    end: new Date(td.end),
                    start: new Date(td.start),
                    // duration
                }

            })
            if (tasksData.length >= 1) {
                setTasks(tasksData)
            } else {
                setTasks([])
            }

        } else {
            setTasks([])
        }
    }, [data,loading])

    const handleCloseModal = () => {
        setShowModal(false)
        setCurrent(null)

    }

    const handleZoom = (setTransform:any,rest:any,type:string) =>{
        let newscale = Number(scale);
        if(type === "out"){
            if(scale > 0.4){
                newscale = scale-0.1  
            }
        } else if(type === "in") {
            if(scale < 1.5){
                newscale = scale+0.1
            }
            
        } else {
            newscale=1
        }
        setScale(newscale)
    }
    
    return (

        <div className="row dark:bg-[#111928] relative" style={{ margin: "10px", width: "100%" }}>
                    
                {loading ? (
                    <div className="flex items-center flex-col justify-center w-full h-[50vh] bottom-0 relative">
                        <img alt="cadence Loader" className="w-40 mb-1" src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/loader.gif" />
                        <div className="text-center dark:text-white opacity-50 text-base font-normal">Cadence is working<br />on your request</div>
                        <div className="absolute opacity-50 bg-slate-900 top-0 right-0 left-0 bottom-0"></div>
                    </div>
                ) : (
                tasks && tasks.length >1  && GANTT_VIEW_NEW ?( <div className="flex flex-col relative group ">
                                <div className=" ml-auto mr-10 top-32 absolute right-0 z-[999] flex">
                                    <Button theme={{base:"!p-0"}} size={"xs"}   className=" mb-2  rounded-none !bg-transparent" onClick={()=>handleZoom("","","in")} ><HiOutlineZoomIn className="text-gray-800 dark:text-white" /> </Button>
                                    <Button theme={{base:"!p-0"}} size={"xs"}    className=" mb-2 p-0 rounded-none !bg-transparent" onClick={()=>handleZoom("","","out")} ><HiOutlineZoomOut className="text-gray-800 dark:text-white" /> </Button>
                                    <Button theme={{base:"!p-0"}} size={"xs"}   className=" mb-2 p-0 rounded-none !bg-transparent !text-gray-800 dark:!text-white" onClick={ ()=>handleZoom("","","reset")} >Reset </Button>
                                </div>
                                    <GanntNew 
                                        ZoomClick={ZoomClick} 
                                        scale={scale} 
                                        tasks={tasks} 
                                        sim_flag={sim_flag} 
                                        duration={duration} 
                                        duration_with_working_days={duration_with_working_days} 
                                        duration_with_delay={duration_with_delay} 
                                        isTemplate={isTemplate} 
                                        onDoubleClick={handleDblClick} 
                                    />
                            </div>
                    ): <div className="dark:text-white text-gray-800 flex justify-center items-center h-[50vh]">
                          {!sim_flag && hasSimulationTasks ? (
                            <div className="text-center">
                              <p>You currently have no task data in live mode.</p>
                              <p className="font-semibold text-blue-600 dark:text-blue-400">Tasks are available in simulation mode. Please toggle to simulation mode to view them.</p>
                            </div>
                          ) : !sim_flag ? (
                            <div className="text-center">
                              <p>You currently have no task data in live mode. Please create a new task to begin.</p>
                            </div>
                          ) : (
                            "You currently have no task data in simulation mode. Please create a new task to begin."
                          )}
                        </div>
                )}

            {showModal && !isTemplate && <TaskCompletionUpdateModal
                            project_id={project_id ? project_id : projectId}
                            isVisiable={showModal}
                            onClose={handleCloseModal}
                            selectedTask={current}
                            handleAddNewTask={handleCloseModal}
                            tasks={tasks}
                            members={members}
                            sim_flag={sim_flag}
                        />}
            {showModal && isTemplate && <TemplateTaskTableModal
                            project_id={project_id ? project_id : projectId}
                            isVisiable={showModal}
                            onClose={handleCloseModal}
                            selectedTask={current}
                            handleAddNewTask={handleCloseModal}
                            tasks={tasks}
                            members={members}
                            sim_flag={sim_flag}
                        />}
            
        </div>
    );
};

export default GanttView;
